import Request from '../request'
import type { AxiosResponseType } from '../../types/api/responses/common'
import type { CountriesResponseType } from '../../types/api/responses/countries'

export function fetchCountriesAndCodes(): Promise<AxiosResponseType<CountriesResponseType>> {
	return Request.get({
		url: `/countries`,
	})
}
